<template>
  <div class="form-base__footer">
    <v-row>
      <v-col>
        <div class="button-box justify-space-between">
          <v-btn
            depressed
            class="button-base-white button-base"
            @click="onCancel"
            >Отмена
          </v-btn>

          <div>
            <v-btn
              v-if="!firstStep"
              @click="$emit('prev-btn-click')"
              :loading="loadingNext"
              :disabled="loadingNext"
              depressed
              color="primary"
              class="button-base ml-5"
              >Назад
            </v-btn>

            <v-btn
              depressed
              color="primary"
              class="button-base ml-5"
              :loading="loadingNext"
              :disabled="loadingNext"
              @click="$emit('next-btn-click')"
              >Далее
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    firstStep: {
      type: Boolean,
      default: false,
    },
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onCancel() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>
